import React from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { labels } from "../../../../../../../localization/labels";
import ButtonBar from "../../../../../../core/ButtonBar";
import ComponentHeader from "../../../../../../core/ComponentHeader/ComponentHeader";
import SubmitControl from "../../../../../../core/SubmitControl/SubmitControl";
import ClassificationAdditionalData from "./additionalData";

const generalData = props => {
  return (
    <Form>
      <Form.Group controlId="name">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.name}</Form.Label>
          </Col>
          <Col>
            <SubmitControl
              autoFocus
              type="text"
              placeholder={labels.namePlaceholder}
              value={props.entity.name}
              validationRule={props.validationRules.name}
              onChange={props.onChange}
              maxLength={props.maxLength.name}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group controlId="code">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.code}</Form.Label>
          </Col>
          <Col>
            <SubmitControl
              placeholder={labels.codePlaceholder}
              value={props.entity.code}
              onChange={props.onChange}
              maxLength={props.maxLength.code}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group controlId="description">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.description}</Form.Label>
          </Col>
          <Col>
            <SubmitControl
              as="textarea"
              placeholder={labels.descriptionPlaceholder}
              value={props.entity.description}
              onChange={props.onChange}
              maxLength={props.maxLength.description}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group controlId="dateFromTo">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.dateFromTo}</Form.Label>
          </Col>
          <Col sm="5">
            <SubmitControl
              type="dateRange"
              placeholder={[
                labels.dateFromPlaceholder,
                labels.dateToPlaceholder
              ]}
              validationRule={props.validationRules?.dateFromTo}
              value={props.entity.dateFromTo}
              onChange={props.onChange}
              controlId={"dateFromTo"}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>
    </Form>
  );
};

const ClassificationDetail = props => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <ComponentHeader
          title={labels.classification}
          id={props.entity.id}
          showBackButton
        />
        <div className="bordered_bottom_rounded containerShadow">
          {generalData(props)}
          <Tabs id="km_class_admin_id" className="Tabs">
            <Tab
              eventKey="generalClassification"
              title={labels.additionalData}
              className="Tab"
            >
              <ClassificationAdditionalData
                messageHandler={props.messageHandler}
                entity={props.entity}
                onChange={props.onChange}
                maxLength={props.maxLength}
                isNew={props.isNew}
                validationRules={props.validationRules}
                statuses={props.statuses}
                types={props.types}
                possibleParents={props.possibleParents}
              />
            </Tab>
          </Tabs>
        </div>
        <ButtonBar
          disabled={props.disabled}
          onDelete={props.isNew ? undefined : props.handleOnDelete}
          onSave={props.onSave}
        />
      </div>
    </div>
  );
};

export default ClassificationDetail;
